import { useState } from "react";
import NewCalendar from "./NewCalendar/NewCalendar";

const TABS = [
  { id: "calendar", label: "Calendar" },
  { id: "whiteboard", label: "Whiteboard" },
  { id: "requests", label: "Requests" },
];

const NewAppointment = () => {
  const [selectedTab, setSelectedTab] = useState("calendar");

  return (
    <>
      <div className="back-white flex-row-ali-cen ph20 pv3">
        {TABS.map(({ id, label }) => (
          <div key={id} className="ph10pv3" onClick={() => setSelectedTab(id)}>
            <div
              className={`flex-center cursor ${
                selectedTab === id ? "pet-det-sel-tab" : "pet-det-un-sel-tab"
              }`}
            >
              {label}
            </div>
          </div>
        ))}
      </div>
      {selectedTab === "calendar" ? <NewCalendar /> : null}
    </>
  );
};

export default NewAppointment;
